module.exports = __WEBPACK_EXTERNAL_MODULE_15__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs2":"vue","commonjs":"vue","amd":"vue"}
// module id = 15
// module chunks = 0 1